import { ApiException } from '../../api/exceptions'
import PeriodsApi from '../../api/PeriodsApi'
import { SET_SELECTED_PERIOD_INFO, SET_SELECTED_PERIOD_INFO_ERROR, SET_SELECTED_PERIOD_INFO_LOADING, SET_SELECTED_PERIOD_INFO_RESET } from '../types'

export const getPeriodInfo = (slug) => {
  return async (dispatch) => {

    dispatch(setLoading())
    
    const api = new PeriodsApi();

    await api.get(slug)
      .then(data => dispatch(setInfo(data)))
      .catch(e => {
        let message = 'Hubo un error al procesar la solicitud. Intente más tarde.';
        
        if (e instanceof ApiException){
          message = e.message;
        }

        dispatch(setError(message))
    });
  }
}

export const resetPeriod = () => {
  return dispatch => dispatch(resetInfo())
}

/** action creators */
const setLoading = () => ({type: SET_SELECTED_PERIOD_INFO_LOADING})

const setInfo = payload => ({type: SET_SELECTED_PERIOD_INFO, payload })

const resetInfo = () => ({type: SET_SELECTED_PERIOD_INFO_RESET})

const setError = payload => ({type: SET_SELECTED_PERIOD_INFO_ERROR, payload })